<script setup lang="ts">
import { chunkLoadFailed } from "../chunkLoadFailure";

function reload() {
	// A plain reload keeps the editor's beforeunload guard in play.
	window.location.reload();
}
</script>

<template>
	<div v-if="chunkLoadFailed" class="chunk-error" role="alert">
		<div class="chunk-error-text">
			<strong>Oops, something didn't load.</strong>
			<span>Check your connection and try again.</span>
		</div>
		<button type="button" class="brand" autofocus @click="reload">Reload</button>
	</div>
</template>

<style scoped lang="scss">
/* Same look as the fallback in index.html. App.vue hides the rest of the app behind it. */
.chunk-error {
	position: fixed;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	z-index: 6000;
	box-sizing: border-box;
	display: flex;
	flex-flow: column nowrap;
	align-items: center;
	justify-content: center;
	gap: 16px;
	padding: 16px;
	background: #e9e9e9;
	color: #333;
	font-size: 16px;
	line-height: 1.4;
	text-align: center;
}

.chunk-error-text {
	display: flex;
	flex-flow: column nowrap;
	gap: 4px;
}
</style>
